import { Heading, Flex, Skeleton } from "@chakra-ui/react";
import { upperFirst } from "lodash";
import { NA } from "components/Shared/EmptyPlaceholder";
import LabeledValue from "components/Shared/LabeledValue";
import { formatInteger, titleCase } from "utils/formatting";

type Props = {
  isLoading?: boolean;
  isLoadingExisting?: boolean;
  numExisting: number | undefined | null;
  numRows: number | undefined | null;
  pluralLabel: string;
};

export default function CountsSection({
  isLoading,
  isLoadingExisting,
  numExisting,
  numRows,
  pluralLabel,
}: Props) {
  const numNew =
    typeof numRows === "number" && typeof numExisting === "number"
      ? numRows - numExisting
      : null;

  const upperFirstPluralLabel = upperFirst(pluralLabel);

  return (
    <>
      <Heading as="h3" size="sm" color="magenta.veryDark">
        {titleCase(pluralLabel)}
      </Heading>
      <Flex mx={-2} flexWrap="wrap" sx={{ "> *": { m: 2, minW: "7em" } }}>
        <LabeledValue
          label="Import"
          value={
            <Skeleton isLoaded={!isLoading} display="inline-block">
              {formatInteger(numRows) || <NA />}
            </Skeleton>
          }
          isLarge
          helpText={`${upperFirstPluralLabel} found in the uploaded Excel file that will be imported.`}
        />

        <LabeledValue
          label="Existing"
          value={
            <Skeleton
              isLoaded={!isLoading && !isLoadingExisting}
              display="inline-block"
            >
              {formatInteger(numExisting) || <NA />}
            </Skeleton>
          }
          isLarge
          helpText={
            <>
              {upperFirstPluralLabel} that already exist in the system and have
              the same Name as ones to be imported. These {pluralLabel} will be{" "}
              <strong>updated</strong> to match the import.
            </>
          }
        />

        <LabeledValue
          label="New"
          value={
            <Skeleton
              isLoaded={!isLoading && !isLoadingExisting}
              display="inline-block"
            >
              {formatInteger(numNew) || <NA />}
            </Skeleton>
          }
          isLarge
          helpText={
            <>
              {upperFirstPluralLabel} that do not already exist in the system
              and will be <strong>created</strong>.
            </>
          }
        />
      </Flex>
    </>
  );
}
